export const ru = {
    'disabled-note': 'Можно сгенерировать не более {count} фраз',
    generate: 'Создать комбинации',
    'note-expanded-mode':
        'Комбинатор позволяет создать набор ключевых фраз путём перемешивания добавленных фраз во всех сочетаниях. Вы можете добавить до 7 групп слов.',
    'note-hidden-mode': 'Вы можете создать ключевые фразы путем перемножения до 7 групп слов.',
    title: 'Комбинатор ключевых фраз'
};
